import {PageHead} from 'core/modules/PageHead';
import {NextPage} from 'next';
import {BrandsListingPage} from 'modules/brands/pages/BrandsListingPage';
import {getBrandsList, useGetBrandsListQuery} from 'modules/brands/services';
import {withBasicDataServerSide} from 'core/next/controllers';
import {getSeo} from 'modules/seo/services';
import {IBreadcrumb} from 'modules/seo/types';

interface IProps {
    breadcrumbs?: IBreadcrumb[];
}

const BrandsPage: NextPage<{pageProps: IProps}> = ({pageProps: {breadcrumbs = []}}) => {
    const {data} = useGetBrandsListQuery();

    const seoData = data?.seo;
    const title = seoData?.metaTitle;
    const robots = seoData?.robots;

    return (
        <>
            <PageHead robots={robots} title={title} />
            <BrandsListingPage breadcrumbs={breadcrumbs} />
        </>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store) => {
    await store.dispatch(getBrandsList.initiate());

    const seoResponse = await store.dispatch(
        getSeo.initiate({
            type: 'brands',
        }),
    );

    return {
        props: {
            breadcrumbs: seoResponse.data?.breadcrumbs ?? [],
        },
    };
});

export default BrandsPage;
